import {createApp} from "vue";
import QuotationForm from "./Components/QuotationForm.vue";

const app = createApp({
    components: {QuotationForm}
});

app
    .component('QuotationForm', QuotationForm);

app.mount('#artitex');